import { isEmpty } from "./common";
import Request from "./Request";
import urls from "./urls";

const apiRequest = new Request(
  () => {},
  () => {},
  () => {}
);

// export const getUserLogin = (params) => {
//   return apiRequest.post(`${urls.BASE_URL + urls.login.USER_LOGIN}`, params);
// };
// export const LoginPasswordReset = (params) => {
//   return apiRequest.post(
//     `${urls.BASE_URL + urls.login.RESET_PASSWORD}`,
//     params
//   );
// };

export const getUserAccount = (params) => {
  return apiRequest.get(
    `${urls.BASE_URL + urls.login.GET_USER_ACCOUNT}`,
    params
  );
};


export const getUserList = (params, pagination) => {
  const { currentPage, pageSize } = pagination;
  return apiRequest.post(
    `${
      urls.BASE_URL + urls.users.GET_USER_LIST
    }?pageNo=${currentPage}&pageSize=${pageSize}`,
    params
  );
};

// export const forgetPasswordGenerateOtp = (params) => {
//   return apiRequest.post(
//     `${urls.BASE_URL + urls.login.FORGET_PASSWORD_GENERATE_OPT}`,
//     params
//   );
// };
export const updateUserDaital = (params) => {
  return apiRequest.post(`${urls.BASE_URL + urls.users.EDIT_USER}`, params);
};

export const deteleUserFromList = (id) => {
  return apiRequest.get(`${urls.BASE_URL + urls.users.DELETE_USER}/${id}`);
};

export const userStatusUpdate = (id, status) => {
  return apiRequest.get(
    `${urls.BASE_URL + urls.users.USER_STATUS}/${id}/${status}`
  );
};

export const addUser = (params) => {
  return apiRequest.post(`${urls.BASE_URL + urls.users.ADD_USER}`, params);
};

export const changeAdminPassword = (params) => {
  return apiRequest.post(
    `${urls.BASE_URL + urls.admin.CHANGE_PASSWORD}`,
    params
  );
};
export const verificationAadhar = (params) => {
  return apiRequest.post(`${urls.BASE_URL + urls.users.VERYFY_AADHAR}`, params);
};
export const userPackageMapping = (userId, pkgCode) => {
  return apiRequest.post(
    `${
      urls.BASE_URL + urls.users.USER_PPACKAGE_MAPPING
    }?userId=${userId}&pkgCode=${pkgCode}`,
    {}
  );
};
export const aepsVerifyOtp = (params) => {
  return apiRequest.post(`${urls.BASE_URL + urls.users.OTP_VERIFY}`, params);
};
export const bankDetailsKyc = (params) => {
  return apiRequest.post(
    `${urls.BASE_URL + urls.users.ADD_BANK_DETAILS}`,
    params
  );
};

export const getMainTreeBalance = () => {
  return apiRequest.get(`${urls.BASE_URL + urls.Overview.MAIN_TREE_BALANCE}`);
};
export const getOutstandDetail = () => {
  return apiRequest.get(`${urls.BASE_URL + urls.Overview.OUTSTANDING_DETAIL}`);
};
export const getTotalPayinPauout = (params) => {
  return apiRequest.post(
    `${urls.BASE_URL + urls.Overview.TOTAL_PAYIN_PAYOUT}`,
    params
  );
};

export const getAepsTreeBalance = () => {
  return apiRequest.get(`${urls.BASE_URL + urls.Overview.AEPS_TREE_BALANCE}`);
};
export const getUsersData = (userType) => {
  return apiRequest.get(
    `${urls.BASE_URL + urls.Overview.TOTAL_USERS}?userType=${userType}`
  );
};
export const getsettlementBalance = (txnFilter) => {
  return apiRequest.get(
    `${urls.BASE_URL + urls.Overview.SETTLEMENT_BALANCE}?txnFilter=${txnFilter}`
  );
};
export const getLiveBalance = () => {
  return apiRequest.get(`${urls.BASE_URL + urls.Overview.LIVE_BALANCE}`);
};
export const getServiceDetail = (params) => {
  return apiRequest.post(
    `${urls.BASE_URL + urls.Overview.SERVICE_DETAILS}`,
    params
  );
};

export const operatorList = (params) => {
  return apiRequest.post(
    `${urls.BASE_URL + urls.Operators.OPERATORS_LIST}`,
    params
  );
};
export const serviceList = (params) => {
  return apiRequest.post(
    `${urls.BASE_URL + urls.Service.SERVICE_LIST}`,
    params
  );
};
export const updateServiceStatus = (params) => {
  return apiRequest.post(
    `${urls.BASE_URL + urls.UpdateService.UPDATE_SERVICE}`,
    params
  );
};

export const searchUser = (mobile, value = false) => {
  return apiRequest.get(
    `${
      urls.BASE_URL + urls.users.USER_SEARCH
    }/${mobile}?isWalletRequired=${value}`
  );
};
export const debitCreditList = (params) => {
  return apiRequest.post(
    `${urls.BASE_URL + urls.ADD_DEBIT_CREDIT.DEBIT_CREDIT_LIST}`,
    params
  );
};
export const getTransactionList = (params) => {
  return apiRequest.post(
    `${urls.BASE_URL + urls.transactions.TRANSACTION_LIST}`,
    params
  );
};
export const refundAddmoneyTransaction = (orderId) => {
  return apiRequest.get(
    `${urls.BASE_URL + urls.transactions.ADDMONEY_TRANSACTION_REFUND}orderId=${orderId}`
  );
};

export const checkTransactionStatus = (params) => {
  return apiRequest.post(
    `${urls.BASE_URL + urls.transactions.CHECK_TRANSACTION_STATUS}`,
    params
  );
};
export const getWalletList = (params) => {
  return apiRequest.post(
    `${urls.BASE_URL + urls.wallet.WALLET_SUMMARY}`,
    params
  );
};
export const getDebit = (params) => {
  return apiRequest.post(
    `${urls.BASE_URL + urls.ADD_DEBIT_CREDIT.DEBIT}`,
    params
  );
};
export const getCredit = (params) => {
  return apiRequest.post(`${urls.BASE_URL + urls.ADD_DEBIT_CREDIT.CREDIT}`);
};

export const createDebitCredit = (params) => {
  return apiRequest.post(
    `${urls.BASE_URL + urls.ADD_DEBIT_CREDIT.CREATE_DEBIT_CREDIT}`,
    params
  );
};
export const getDebitCreditApprove = (param, status) => {
  return apiRequest.get(
    `${
      urls.BASE_URL + urls.ADD_DEBIT_CREDIT.DEBIT_CREDIT_APPROVE
    }?txnId=${param}&status=${status}`
  );
};
export const rolePermission = (role_code) => {
  return apiRequest.get(
    `${urls.BASE_URL + urls.roleAndPermission.Role_Permission}/${role_code}`
  );
};
export const getRoleAndPermissionList = () => {
  return apiRequest.get(
    `${urls.BASE_URL + urls.roleAndPermission.ALL_PERMISSION}`
  );
};

export const updatePermissionList = (params) => {
  return apiRequest.post(
    `${urls.BASE_URL + urls.roleAndPermission.UPDATE_PERMISSION}`,
    params
  );
};
export const PackageList = (params) => {
  return apiRequest.post(
    `${
      urls.BASE_URL + urls.package.PACKAGE_UPDATE
    }?pkgCode=DEFAULT&serviceCode=PAY_OUT&amount=1001&route=NEFT`
  );
};
export const getPackageList = () => {
  return apiRequest.get(`${urls.BASE_URL + urls.package.PACKAGE_LST}`);
};

export const addPackage = (params) => {
  return apiRequest.post(
    `${urls.BASE_URL + urls.package.CREATE_PACKAGE}`,
    params
  );
};
export const addPackageServices = (params, pkgCode) => {
  return apiRequest.post(
    `${
      urls.BASE_URL + urls.package.CREATE_PACKAGE_SERVICES
    }?pkgCode=${pkgCode}`,
    params
  );
};
export const getPackageCodeList = () => {
  return apiRequest.get(`${urls.BASE_URL + urls.package.PACKAGE_CODE_LIST}`);
};
export const getPackageCodeDetail = (packageUuid) => {
  return apiRequest.get(
    `${
      urls.BASE_URL + urls.package.PACKAGE_CODE_DETAIL
    }?packageUuid=${packageUuid}`
  );
};
export const updatePackageServices = (param) => {
  return apiRequest.post(
    `${urls.BASE_URL + urls.package.PACKAGE_UPDATE}`,
    param
  );
};
export const updateConfigurationServices = (param) => {
  return apiRequest.post(
    `${urls.BASE_URL + urls.package.PACKAGE_PRICE_CONFIGURATION_UPDATE}`,
    param
  );
};

export const getRoute = (serviceType) => {
  return apiRequest.get(
    `${urls.BASE_URL + urls.package.PACKAGE_ROUTE}?serviceType=${serviceType}`
  );
};

export const getBankList = () => {
  return apiRequest.get(`${urls.BASE_URL}${urls.Service.AEPS_BANK_LIST}`);
};

export const updateAdminProfile = (params) => {
  return apiRequest.put(
    `${urls.BASE_URL + urls.admin.EDIT_ADMIN_USER}`,
    params
  );
};

export const tickectList = (param, page, pagesize) => {
  return apiRequest.post(
    `${
      urls.BASE_URL + urls.ticketManagement.GET_TICKET_LIST
    }?pageNo=${page}&pageSize=${pagesize}`,
    param
  );
};
export const createTicket = (param) => {
  return apiRequest.post(
    `${urls.BASE_URL + urls.ticketManagement.CREATE_TICKET}`,
    param
  );
};

export const updateTicket = (param) => {
  return apiRequest.post(
    `${urls.BASE_URL + urls.ticketManagement.UPDATE_TICKET}`,
    param
  );
};
export const getCategoryList = () => {
  return apiRequest.get(
    `${urls.BASE_URL}${urls.ticketManagement.GET_CATEGORY}`
  );
};
export const getTicketStatus = () => {
  return apiRequest.get(`${urls.BASE_URL}${urls.ticketManagement.GET_STATUS}`);
};
export const getTicketRequestType = () => {
  return apiRequest.get(
    `${urls.BASE_URL}${urls.ticketManagement.GET_REQUESTTYPE}`
  );
};

export const getTicketPriority = () => {
  return apiRequest.get(
    `${urls.BASE_URL}${urls.ticketManagement.GET_PRIORITY}`
  );
};
export const getChatMessage = (ticketId, toId, currPage, pageSize) => {
  return apiRequest.get(
    `${
      urls.BASE_URL + urls.chatData.GET_MESSAGE
    }?ticketId=${ticketId}&pageNo=${currPage}&pageSize=${pageSize}&toId=${toId}`
  );
};
export const sendChatMessage = (param) => {
  return apiRequest.post(
    `${urls.BASE_URL + urls.chatData.SEND_MESSAGE}`,
    param
  );
};

export const sendMoneyRequest = (params) => {
  return apiRequest.post(
    `${urls.BASE_URL}${urls.sendMoney.SEND_MONEY_URL}`,
    params
  );
};
export const getApiUserList = (pageSize = 10, pageNo=1 ) => {

  return apiRequest.get(
    `${urls.BASE_URL}${urls.api.GET_API_USER_LIST}?pageNo=${pageNo}&pageSize=${pageSize}`
  );
};
export const createVendorUser = (params) => {
  return apiRequest.post(
    `${urls.BASE_URL}${urls.api.CREATE_VENDOR_USER}`,
    params
  );
};

export const getVendorTransctionList = (params) => {
  return apiRequest.post(
    `${urls.BASE_URL}${urls.api.VENDOR_TRANSACTION_LIST}`,
    params
  );

};

export const getViewLiveBalance = () => {
  return apiRequest.get(
    `${urls.BASE_URL}${urls.Overview.VIEW_LIVE_BALANCE}`
  
  );
  }
export const geTPaybackStatus = (txnValue) => {
  return apiRequest.get(
    `${urls.BASE_URL}${urls.wallet.CHECKPAYBACK_STATUS}/${txnValue}`
  
  );
  }
export const diosmVerifyPan = (params) => {
  return apiRequest.post(
    `${urls.BASE_URL}${urls.users.DIOSM_VERIFY_PAN }`,
    params
  );
  }
export const diosmVerifyPanConfirm = ( params) => {
  return apiRequest.post(
    `${urls.BASE_URL}${urls.users.DIOSM_VERIFY_PAN_CONFIRM }`,
    params
  );
  }
export const diosmAadharKyc = (params) => {
  return apiRequest.post(
    `${urls.BASE_URL}${urls.users.DIOSM_AADHAR_KYC }`,
    params
  
  );
  }
export const diosmAadharOtpVerify = (params) => {
  return apiRequest.post(
    `${urls.BASE_URL}${urls.users.DIOSM_AADHAR_OTP_VERIFY }`,
    params
  );
};


//Inventory Management 

export const createInventory = (params) => {
  return apiRequest.post(
    `${urls.BASE_URL}${urls.inventoryManage.CREATE_INVENTORY}`,
    params
  );
};
export const addPosDevice = (params) => {
  return apiRequest.post(
    `${urls.BASE_URL}${urls.inventoryManage.ADD_POS}`,
    params
  );
};

export const getInventoryList = (params) => {
  return apiRequest.post(
    `${urls.BASE_URL}${urls.inventoryManage.GET_INVENTORY_DETAIL}`,
    params
  );
};
export const updateInventory = (params) => {
  return apiRequest.put(
    `${urls.BASE_URL}${urls.inventoryManage.UPDATE_INVENTORY}`,
    params
  );
};

export const assignDevice = (inventoryId,userId) => {
  return apiRequest.get(
    `${urls.BASE_URL}${urls.inventoryManage.ASSIGN_DEVICE}?inventoryId=${inventoryId}&userId=${userId}`,
  );
};
export const unassignDevice = (userId) => {
  return apiRequest.put(
    `${urls.BASE_URL}${urls.inventoryManage.UNASSIGNED_DEVICE}/${userId}`,
  );
};
export const deleteInventory = (uuid) => {
  return apiRequest.delete(
    `${urls.BASE_URL}${urls.inventoryManage.DELETE_INVENTORY}?uuid=${uuid}`,
  );
};
export const assignedDeviceList = (params,currentPage,pageSize) => {
  return apiRequest.post(
    `${urls.BASE_URL}${urls.inventoryManage.ASSIGNED_DEVICE_LIST}?pageNo=${currentPage}&pageSize=${pageSize}`,
    params
  );
};

export const getVendorFundRequestList = (params) => {
  return apiRequest.post(
    `${urls.BASE_URL}${urls.api.VENDOR_FUND_REQUEST_LIST}`,
    params
  );
};
export const getVendorFundRequestApproval = (params) => {
  return apiRequest.post(
    `${urls.BASE_URL}${urls.api.VENDOR_FUND_REQUEST_APPROVAL}`,
    params
  );
};
export const configService = (service) => {
  return apiRequest.post(
    `${urls.BASE_URL}${urls.package.CONFIG_SERVICE}${service}`,
    {}
  );
};

export const cdmCardList = (params) => {
  return apiRequest.post(
    `${urls.BASE_URL}${urls.cmd.CARD_lIST}`,
    params
  );
};

export const addCard = (params) => {
  return apiRequest.post(
    `${urls.BASE_URL}${urls.cmd.ADD_CARD}`,
    params
  );
};
export const addBulkCard = (params) => {
  return apiRequest.post(
    `${urls.BASE_URL}${urls.cmd.ADD_BULK_CARD}`,
    params
  );
};
export const cdmUpdateStatus = (params) => {
  return apiRequest.post(
    `${urls.BASE_URL}${urls.cmd.CDM_UPDATE_STATUS}`,
    params
  );
};
export const cdmAssignedList = (params) => {
  return apiRequest.post(
    `${urls.BASE_URL}${urls.cmd.ASSIGNED_CDM_LIST}`,
    params
  );
};
export const mappCdnCard = (params) => {
  return apiRequest.post(
    `${urls.BASE_URL}${urls.cmd.MAPP_CDM_CARD}`,
    params
  );
};
export const updateMapedCardStatus = (params) => {
  return apiRequest.post(
    `${urls.BASE_URL}${urls.cmd.CDM_UPDATE_MAPPED_STATUS}`,
    params
  );
};


export const getDqrListing = (params) => {
  return apiRequest.post(
    `${urls.BASE_URL}${urls.dqr.DQR_LIST}`,
    params
  );
};
export const dqrAssignedList = (params) => {
  return apiRequest.post(
    `${urls.BASE_URL}${urls.dqr.ASSIGNED_DQR_LIST}`,
    params
  );
};
export const addDqrDevice = (params) => {
  return apiRequest.post(
    `${urls.BASE_URL}${urls.dqr.ADD_DQR_CARD}`,
    params
  );
};
export const addBulkDqrCard = (params) => {
  return apiRequest.post(
    `${urls.BASE_URL}${urls.dqr.ADD_BULK_DQR}`,
    params
  );
};

export const mappDqrCard = (params) => {
  return apiRequest.post(
    `${urls.BASE_URL}${urls.dqr.MAPP_DQR_CARD}`,
    params
  );
};

export const updateMapedDqrStatus = (params) => {
  return apiRequest.post(
    `${urls.BASE_URL}${urls.dqr.DQR_UPDATE_MAPPED_STATUS}`,
    params
  );
};

export const dqrUpdateStatus = (params) => {
  return apiRequest.post(
    `${urls.BASE_URL}${urls.dqr.DQR_UPDATE_STATUS}`,
    params
  );
};
export const getHotelList = (params) => {
  return apiRequest.post(
    `${urls.BASE_URL_TRAVEL}${urls.travel.HOTEL_LIST}`,
    params
  );
};
export const getCityList = (params) => {
  return apiRequest.post(
    `${urls.BASE_URL_TRAVEL}${urls.travel.CITY_LIST}`,
    params
  );
};
export const getCountryList = (params) => {
  return apiRequest.post(
    `${urls.BASE_URL_TRAVEL}${urls.travel.COUNTRY_LIST}`,
    params
  );
};
export const getSuggestList = (q,i,type) =>{
  return apiRequest.get(
    `${urls.BASE_URL_TRAVEL}${urls.travel.AUTO_SUGGEST}?q=${q}&i=${i}&type=${type}`,
  ); 
}
export const getViewCity = (params) =>{
  return apiRequest.get(
    `${urls.BASE_URL_TRAVEL}${urls.travel.INFO_CITY}/${params}`,
    params
  );
}
export const getViewHotel = (params) =>{
  return apiRequest.get(
    `${urls.BASE_URL_TRAVEL}${urls.travel.INFO_HOTEL}/${params}`
 
  );
}
export const getViewCountry = (params) =>{
  return apiRequest.get(
    `${urls.BASE_URL_TRAVEL}${urls.travel.INFO_COUNTRY}/${params}`,
    params
  );
}
export const getViewImageHotel = (params) =>{
  return apiRequest.post(
    `${urls.BASE_URL_TRAVEL}${urls.travel.INFO_IMAGE}`,
    params
  );
}
export const AddNewImageHotel = (params) =>{
  return apiRequest.post(
    `${urls.BASE_URL_TRAVEL}${urls.travel.ADD_IMAGE}`,
    params
  );
}
export const AddNewHotel = (params) =>{
  return apiRequest.post(
    `${urls.BASE_URL_TRAVEL}${urls.travel.ADD_HOTEL}`,
    params
  );
}
export const AddNewCity = (params) =>{
  return apiRequest.post(
    `${urls.BASE_URL_TRAVEL}${urls.travel.ADD_CITY}`,
    params
  );
}
export const AddNewCountry = (params) =>{
  return apiRequest.post(
    `${urls.BASE_URL_TRAVEL}${urls.travel.ADD_COUNTRY}`,
    params
  );
}
export const UpdateCountry = (params) =>{
  return apiRequest.post(
    `${urls.BASE_URL_TRAVEL}${urls.travel.UPDATE_COUNTRY}`,
    params
  );
}
export const UpdateCity = (params) =>{
  return apiRequest.post(
    `${urls.BASE_URL_TRAVEL}${urls.travel.UPDATE_CITY}`,
    params
  );
}
export const UpdateHotelDetails = (params) =>{
  return apiRequest.post(
    `${urls.BASE_URL_TRAVEL}${urls.travel.UPDATE_HOTEL}`,
    params
  );
}
export const UpdateImageDetails = (params) =>{
  return apiRequest.post(
    `${urls.BASE_URL_TRAVEL}${urls.travel.UPDTAE_IMAGE}`,
    params
  );
}
export const UpdateHotelStatus = (id) =>{
  return apiRequest.post(
    `${urls.BASE_URL_TRAVEL}${urls.travel.UPDATE_HOTEL_STATUS}/${id}/update/status`
  );
}
export const UpdateCityStatus = (id) =>{
  return apiRequest.post(
    `${urls.BASE_URL_TRAVEL}${urls.travel.UPDATE_CITY_STATUS}/${id}/update/status`
  );
}
export const UpdateCountryStatus = (id) =>{
  return apiRequest.post(
    `${urls.BASE_URL_TRAVEL}${urls.travel.UPDATE_COUNTRY_STATUS}/${id}/update/status`
  );
}

export const getAirlineList = (params) =>{
  return apiRequest.post(
    `${urls.BASE_URL_TRAVEL}${urls.travel.AIRLINE_LIST}`,
    params
  );
}
export const updateAirlineStatus = (id) =>{
  return apiRequest.post(
    `${urls.BASE_URL_TRAVEL}${urls.travel.UPDATE_AIRLINE_STATUS}/${id}/update/status`
  );
}
export const getAirportList = (params) =>{
  return apiRequest.post(
    `${urls.BASE_URL_TRAVEL}${urls.travel.AIRPORT_LIST}`,
    params
  );
}

export const updateAirportStatus = (id) =>{
  return apiRequest.post(
    `${urls.BASE_URL_TRAVEL}${urls.travel.UPDATE_AIRPORT_STATUS}/${id}/update/status`
  );
}
export const updateImageStatus = (id) =>{
  return apiRequest.post(
    `${urls.BASE_URL_TRAVEL}${urls.travel.UPDATE_IMAGE_STATUS}/${id}/update/status`
  );
}

export const getViewAirline = (params) =>{
  return apiRequest.get(
    `${urls.BASE_URL_TRAVEL}${urls.travel.AIRLINE_INFO}${params}`
  );
}
export const updateAirline = (params) =>{
  return apiRequest.post(
    `${urls.BASE_URL_TRAVEL}${urls.travel.UPDATE_AIRLINE}`,
    params
  );
}
export const getViewAirport = (params) =>{
  return apiRequest.get(
    `${urls.BASE_URL_TRAVEL}${urls.travel.AIRPORT_INFO}/${params}`
   
  );
}
export const updateAirport = (params) =>{
  return apiRequest.post(
    `${urls.BASE_URL_TRAVEL}${urls.travel.UPDATE_AIRPORT}`,
    params
  );
}


export const AddAirline = (params) =>{
  return apiRequest.post(
    `${urls.BASE_URL_TRAVEL}${urls.travel.ADD_AIRLINE}`,
    params
  );
}
export const AddAirport = (params) =>{
  return apiRequest.post(
    `${urls.BASE_URL_TRAVEL}${urls.travel.ADD_AIRPORT}`,
    params
  );
}

export const fetchCountryList = () =>{
  return apiRequest.get(`${urls.BASE_URL_TRAVEL}${urls.travel.FETCH_COUNTRY}`);
}


export const fetchBookingist = (params) =>{
  return apiRequest.post(
    `${urls.BASE_URL_TRAVEL}${urls.travel.BOOKING_LIST}`,
    params
  );
}

//


export const getTraveleBalance = (params) => {
  return apiRequest.post(
    `${urls.BASE_URL_TRAVEL}${urls.travel.VIEW_TRAVEL_WALLET_BALANCE}`,
    params
  
  );
  }

 // BULK UPLOAD 

 export const uploadFundFile = (params) =>{
  return apiRequest.post(
    `${urls.BASE_URL}${urls.addFundBulk.UPLOAD_FILE}`,
    params
  );
}
 export const getFundFiles = (params) =>{
  return apiRequest.post(
    `${urls.BASE_URL}${urls.addFundBulk.GET_FILE_LISTING}`,
    params
  );
}
 export const getFundData = (params) =>{
  return apiRequest.post(
    `${urls.BASE_URL}${urls.addFundBulk.GET_FILE_DATA}`,
    params
  );
}
 export const getProcessFund = (uploadId) =>{
  return apiRequest.post(
    `${urls.BASE_URL}${urls.addFundBulk.PROCESS_FUND}?uploadId=${uploadId}`,

  );
}

// b2b Manage Kyc

export const getKucDetails = (id) =>{
  return apiRequest.get(`${urls.BASE_URL}${urls.b2bManageKyc.GET_KYC_DETAILS}${id}`);
}
export const KycApprove = (params) =>{
  return apiRequest.post(`${urls.BASE_URL}${urls.b2bManageKyc.KYC_APPROVE}`,
  params
  );
}
export const KycReject = (params) =>{
  return apiRequest.post(`${urls.BASE_URL}${urls.b2bManageKyc.KYC_REJECT}`,
  params
  );
}


export const getKycStatus = (id) =>{
  return apiRequest.get(`${urls.BASE_URL}${urls.b2bManageKyc.KYC_STATUS}?userId=${id}`);
}
export const getParentDetails = (id) =>{
  return apiRequest.get(`${urls.BASE_URL}${urls.b2bManageKyc.PARENT_DETAILS}/${id}/parent-details`);
}
export const updateParent = (userId,parentId) =>{
  return apiRequest.get(`${urls.BASE_URL}${urls.b2bManageKyc.PARENT_UPDATE}/${userId}/${parentId}`);
}
export const getApproveBank = (beneId) =>{
  return apiRequest.get(`${urls.BASE_URL}${urls.b2bManageKyc.BANK_APPROVE}?beneId=${beneId}`);
}
export const getRejectBank = (beneId) =>{
  return apiRequest.get(`${urls.BASE_URL}${urls.b2bManageKyc.BANK_REJECT}?beneId=${beneId}`);
}
export const getBankDetails = (id) =>{
  return apiRequest.get(`${urls.BASE_URL}${urls.b2bManageKyc.GET_BANK_DETAILS}?userId=${id}`);
}


//referral users

export const addReferralUser = (params) =>{
  return apiRequest.post(`${urls.BASE_URL}${urls.referralUsers.ADD_REFERRAL_USER}`,
  params
  );
}
export const getferralUsers = (params) =>{
  return apiRequest.post(`${urls.BASE_URL}${urls.referralUsers.REFERRAL_USER_LIST}`,
  params
  );
}

//CUSTOMER_TRANSACTION_LIST

export const getCustomer = (params) =>{
  return apiRequest.post(`${urls.BASE_URL}${urls.customer.CUSTOMER_LIST}`,
  params
  );
}
export const updateCustomerStatus = (params) =>{
  return apiRequest.post(`${urls.BASE_URL}${urls.customer.UPDATE_CUSTOMER_STATUS}`,
  params
  );
}
export const getCustomerTxn = (params) =>{
  return apiRequest.post(`${urls.CUSTOMER_BASE_URL}${urls.customer.CUSTOMER_TRANSACTION_LIST}`,
  params
  );
}
export const CustomerTxnSatausUpdate = (params) =>{
  return apiRequest.post(`${urls.CUSTOMER_BASE_URL}${urls.customer.CUSTOMER_TRANSACTION_UPDATE}`,
  params
  );
}
export const CustomerTxnRefund = (params) =>{
  return apiRequest.post(`${urls.CUSTOMER_BASE_URL}${urls.customer.CUSTOMER_TRANSACTION_REFUND}`,
  params
  );
}


//

export const getServicesList = () =>{
  return apiRequest.get(`${urls.BASE_URL}${urls.serviceManagement.GET_SERVICES_LIST}`);
}
export const getAssignServicesList = (uuid) =>{
  return apiRequest.get(`${urls.BASE_URL}${urls.serviceManagement.GET_ASSIGN_SERVICES_LIST}?userId=${uuid}`);
}
export const assignServicesList = (params) =>{
  return apiRequest.post(`${urls.BASE_URL}${urls.serviceManagement.SERVICES_LIST_UPDATE}`,
    params
  );
}
export const getUserCount = (params) =>{
  return apiRequest.post(`${urls.BASE_URL}${urls.login.USER_COUNT}`,
    params
  );
}

//

export const getTelent = (userName) => {
  return apiRequest.get(
    `${urls.BASE_URL + urls.tenant.GET_TENANT}${userName}`,
  );
};
export const approverTenant = (uuid="",docId="",status="") => {

  return apiRequest.get(
    `${urls.BASE_URL + urls.tenant.GET_TENANT_DOC_APPROVE}?tenantId=${uuid}&docId=${docId}&status=${status}`,
  );
};
export const tenantStatusUpdate = (uuid="",status="") => {

  return apiRequest.post(
    `${urls.BASE_URL + urls.tenant.GET_TENANT_UPDATE_STATUS}?tenantId=${uuid}&status=${status}`,{}
  );
};
export const policeVerificationDocUpload = (param,tenantId,docType) => {
  return apiRequest.post(
    `${urls.BASE_URL + urls.tenant.TENANT_POLIC_VERIFICATION_UPLOAD}?tenantId=${tenantId}&docType=${docType}`,
    param
  );
};
export const getTenant = (pageSize,pageNumber,mobileNumber,accommodationId) =>{
  const filter = mobileNumber?"&mobileNumber="+mobileNumber:""
  let acc = ""
  if(!isEmpty(accommodationId)){
acc = `&accommodationId=${accommodationId}`
  }
  
  return apiRequest.get(`${urls.BASE_URL + urls.tenant.GET_TENANTLIST}?page=${pageNumber}${acc}${filter}`,
  );
}

// pg list:
export const getAccommodations = (pageNumber = 0,accommodationId) => {
  let acc=""
  if(!isEmpty(accommodationId)){
acc = `&accommodationId=${accommodationId}`
  }
 return apiRequest.get(`${urls.BASE_URL + urls.tenant.GET_PGLIST}?page=${pageNumber}${acc}`,
  );
};
export const getAccommodationsMap = (pageNumber = 0) => {
 return apiRequest.get(`${urls.BASE_URL + urls.tenant.GET_MAPPING_LIST}?page=${pageNumber}`,
  );
};
export const addPgDetails = (params, type="add") =>{
  let update = ""
  if(type === "update"){
update = "/update"
  }
  return apiRequest.post(
    `${urls.BASE_URL + urls.tenant.ADD_PG}${update}`,
    params
  );
};
export const savePgRoom = (params, type="save") =>{
  let action = "/create";
  if(type === "update"){
       action = "/update";
  }
  return apiRequest.post(
    `${urls.BASE_URL + urls.tenant.SAVE_ROOMS}${action}`,
    params
  );
};
export const getAccommodationsList = () => {
 return apiRequest.get(`${urls.BASE_URL + urls.tenant.PG_LIST}`,
  );
};
export const getRoomsDetails = (uuid) => {
 return apiRequest.get(`${urls.BASE_URL + urls.tenant.ROOM_DETAILS}?accommodationId=${uuid}`,
  );
};

export const verifyAccount = (params) => {
	return apiRequest.post(`${urls.BASE_URL + urls.sendMoney.VERIFY_ACCOUNT}`, params);
};


//
export const LoginPasswordReset = (params) => {
  return apiRequest.post(
    `${urls.BASE_URL + urls.login.RESET_PASSWORD}`,
    params
  );
};

export const forgetPasswordGenerateOtp = (params) => {
  return apiRequest.post(
    `${urls.BASE_URL + urls.login.FORGET_PASSWORD_GENERATE_OPT}`,
    params
  );
};

export const getUserLoginVerifyOtp = (params) => {
  console.log("params", params);
  return apiRequest.post(`${urls.BASE_URL + urls.login.USER_LOGIN_OTP_VERIFY}`, params);
};


  
export const getUserLogin = (params) => {

  return apiRequest.post(`${urls.BASE_URL + urls.login.USER_LOGIN_V2}`, params);
};



export const analyseUpload = (params) => {
	return apiRequest.post(`${urls.BASE_URL + urls.REPORT.ANALYSE_UPLOAD}`, params);
};

export const getAnalyseList = (params) => {
	return apiRequest.post(`${urls.BASE_URL + urls.REPORT.ANALYSE_LIST}`, params);
};

export const getAnalyseDetails = (id) => {
 return apiRequest.get(`${urls.BASE_URL + urls.REPORT.GET_ANALYSE_DETAILS}processId=${id}`,
  );
};
export const getTidReportList = (date) => {
 return apiRequest.get(`${urls.BASE_URL + urls.REPORT.GET_TID_LIST}?date=${date}`,
  );
};

export const settlementApi = (params) => {
  return apiRequest.post(
    `${urls.BASE_URL}${urls.OTHERS.SETTLEMENT_URL}`,
    params
  );
};

export const getTenLog = (params) => {
	return apiRequest.post(`${urls.BASE_URL + urls.REPORT.GET_TXN_LOG}`, params);
};
